/**
 * Campi di un conto che rivelano la liquidità: nascosti a chi non ha
 * `canViewAccountBalances`. Lista unica per backend (redazione delle
 * risposte, input di scrittura) e webapp (form e card del conto).
 */
export const ACCOUNT_BALANCE_FIELDS = [
    'balance',
    'nativeBalance',
    'creditLimit',
    'overdraftExpiresAt',
    'balanceAlertThreshold',
];
/**
 * Metadati di provenienza (BANK/MANUAL/NONE) dei campi fido: rivelerebbero se
 * un fido esiste. Vanno azzerati come i campi saldo nelle risposte, ma NON
 * sono campi saldo in input (la lista sopra serve anche a ometterli).
 */
export const ACCOUNT_BALANCE_SOURCE_FIELDS = [
    'creditLimitSource',
    'overdraftExpiresAtSource',
];
//# sourceMappingURL=account-balance-fields.js.map